import { applyMergeTags } from '../../domain/merge-tags';
import type { RenderMergeMode } from './types';

export function merge(value: string, mode: RenderMergeMode): string {
  return applyMergeTags(value, mode);
}
